import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The AI surface radii (`rounded-ai-*`, globals.css `@theme inline`) are theme
// values tailwind-merge can't see on its own: without this, `rounded-md` and
// `rounded-ai-pill` in one class list would both survive.
// Must equal the `--radius-ai-*` entries in globals.css (ai-token-coverage.test).
export const AI_RADII = ["ai-sm", "ai-md", "ai-bubble", "ai-card", "ai-composer", "ai-pill"]
const twMerge = extendTailwindMerge({ extend: { theme: { radius: AI_RADII } } })

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
